<div class="stack-container border border-0">
  <div
    *ngFor="let item of items"
    class="stack-item border rounded-md shadow-sm p-4 mb-1 cursor-pointer hover:bg-gray-200 flex gap-1 "
    [attr.data-testid]="'stack-item-' + item.id"
    [class.bg-gray-200]="item.id === selectedId"
    (click)="onItemSelected(item)"
  >    <div *ngFor="let column of columns" class="grow">
      <div class="items-center mb-2 last:mb-0 ">
        <div *ngIf="!column.showLabel || column.showLabel.toLowerCase() === 'true'" class="text-gray-500 text-xs mr-2 text-{{ column.align }}">{{ column.title }}</div>
        <div class="font-bold text-gray-700 text-{{ column.align }}">
          <ng-container [ngSwitch]="column.type">
            <ng-container *ngSwitchCase="'boolean'">
              {{ getFieldValue(item, column) ? ('Yes' | translate) : ('No' | translate) }}
            </ng-container>
            <ng-container *ngSwitchCase="'date'">
              @if (getFieldValue(item, column)) {
              {{ getFieldValue(item, column) | date: 'dd - MM - yyyy' }}
              @if (fuseauDeLigne(item); as iana) {
              <app-timezone-icon [iana]="iana"></app-timezone-icon>
              }
              }
            </ng-container>
            <ng-container *ngSwitchCase="'datetime'">
              @if (getFieldValue(item, column)) {
              @if (isSmallScreen()) {
                {{ getFieldValue(item, column) | date: 'dd-MM-yy' }} {{ 'at' | translate }} {{ getFieldValue(item, column) | date: 'HH:mm' }}
              } @else {
                {{ 'on-date' | translate }} {{ getFieldValue(item, column) | date: 'dd / MM / yyyy' }}  {{ 'at' | translate }} {{ getFieldValue(item, column) | date: 'HH - mm' }}
              }
              @if (fuseauDeLigne(item); as iana) {
              <app-timezone-icon [iana]="iana"></app-timezone-icon>
              }
              }
            </ng-container>
            <ng-container *ngSwitchCase="'progress'">
              {{ getFieldValue(item, column) | percent: '1.0-0' }}
            </ng-container>
            <ng-container *ngSwitchDefault>
              {{ getFieldValue(item, column) }}
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
